import Sprite from "app/components/sprite";
import { useAnimation } from "app/hooks/useAnimation";
import { useI18nLanguage } from "app/hooks/i18n";
import customerQueriesImgAr from "app/images/collections/customer-queries-ar.png";
import customerQueriesImg from "app/images/collections/customer-queries.png";
import personalCollectionsImgAr from "app/images/collections/personal-collections-ar.png";
import personalCollectionsImg from "app/images/collections/personal-collections.png";
import seasonalEventsImgAr from "app/images/collections/seasonal-events-ar.png";
import seasonalEventsImg from "app/images/collections/seasonal-events.png";
import specialOccasionsImgAr from "app/images/collections/special-occasions-ar.png";
import specialOccasionsImg from "app/images/collections/special-occasions.png";
import { useRef } from "react";
import { Trans } from "react-i18next";

export const UseCasesItemsSection = () => {
  const { locale: language } = useI18nLanguage();
  const item1 = useRef(null);
  const image1 = useRef(null);
  const item2 = useRef(null);
  const image2 = useRef(null);
  const item3 = useRef(null);
  const image3 = useRef(null);
  const item4 = useRef(null);
  const image4 = useRef(null);

  useAnimation([item1, image1, item2, image2, item3, image3, item4, image4]);

  return (
    <section className="relative z-10 h-full overflow-hidden bg-white font-montserrat">
      <div className="zbooni-layout pb-20 pt-10">
        <div className="mx-auto flex max-w-md flex-col gap-10 md:max-w-none md:gap-0">
          <div className="flex flex-col gap-8 md:gap-0 ltr:md:flex-row rtl:md:flex-row-reverse ">
            <div className="relative order-2 flex flex-1 items-center justify-center md:order-1">
              <Sprite
                name="zigzag-to-top-right"
                className="absolute -bottom-4 h-[150px] w-[310px] scale-x-[-1] md:-left-16 md:bottom-0 md:h-[200px] md:w-[400px] lg:-left-24 lg:bottom-4 lg:h-[245px] lg:w-[510px] xl:-bottom-4 xl:left-4"
              />
              <img
                ref={image1}
                data-animation="animate__animated animate__fadeInLeft"
                src={
                  language == "ar" ? specialOccasionsImgAr : specialOccasionsImg
                }
                alt="mother's day collection"
                className="relative left-8 z-10 mx-auto w-[262px] md:left-0 md:w-[414px]"
              />
            </div>
            <div
              ref={item1}
              data-animation="animate__animated fade-in-slide-down"
              className="z-10 order-1 flex flex-1 flex-col gap-2 md:order-2 md:gap-3 md:py-20 md:pl-5 lg:gap-4 lg:px-10 lg:py-28"
            >
              <h1
                lang="en"
                className="text-[45px] font-extrabold leading-[54px] text-green ltr:text-left rtl:text-right md:text-6xl md:leading-[70px] lg:text-7xl"
              >
                01
              </h1>
              <p className="text-lg font-extrabold leading-5 md:text-xl md:leading-7 lg:text-2xl">
                <Trans>Special occasions</Trans>
              </p>
              <p className="max-w-lg text-sm font-medium leading-4 md:text-base md:leading-6 lg:text-lg">
                <Trans>
                  Mother’s day, Valentine’s day, Eid-al-Fitr , etc. You can
                  create collections with gift ideas specific to these occasions
                  and send them to your customers over chat.
                </Trans>
              </p>
            </div>
          </div>
          <div className="flex flex-col gap-8 md:gap-0 ltr:md:flex-row rtl:md:flex-row-reverse ">
            <div
              ref={item2}
              data-animation="animate__animated fade-in-slide-down"
              className="z-10 flex flex-1 flex-col gap-2 md:gap-3 md:py-20 md:pr-5 lg:gap-4 lg:px-10 lg:py-28"
            >
              <h1
                lang="en"
                className="text-[45px] font-extrabold leading-[54px] text-yellow-dark ltr:text-left rtl:text-right md:text-6xl md:leading-[70px] lg:text-7xl"
              >
                02
              </h1>
              <p className="text-lg font-extrabold leading-5 md:text-xl md:leading-7 lg:text-2xl">
                <Trans>Seasonal events</Trans>
              </p>
              <p className="max-w-lg text-sm font-medium leading-4 md:text-base md:leading-6 lg:text-lg">
                <Trans>
                  Back to school, Summer Sale, Shopping Festival, etc. Create
                  collections geared towards seasonal events to promote your
                  products or services. The best part? You can personalize your
                  message to win back customers.
                </Trans>
              </p>
            </div>
            <div className="relative flex flex-1 items-center justify-center">
              <Sprite
                name="double-dome-down"
                className="absolute top-2 h-[246px] w-[244px] translate-x-4 sm:left-32 sm:translate-x-0 md:h-[300px] md:w-[300px] lg:left-16 lg:top-4 lg:h-[381px] lg:w-[379px] xl:-top-4 xl:left-40"
              />
              <img
                ref={image2}
                data-animation="animate__animated animate__fadeInRight"
                src={language == "ar" ? seasonalEventsImgAr : seasonalEventsImg}
                alt="back to school collection"
                className="relative top-8 z-10 mx-auto w-[265px] md:top-auto md:w-[412px]"
              />
            </div>
          </div>
          <div className="flex flex-col gap-8 md:gap-0 ltr:md:flex-row rtl:md:flex-row-reverse ">
            <div className="relative order-2 flex flex-1 items-center justify-center md:order-1">
              <Sprite
                name="diagonal-dome"
                className="absolute left-6 top-36 h-[230px] w-[230px] md:left-0 md:top-52 md:h-[270px] md:w-[270px] lg:-left-4 lg:top-60 lg:h-[320px] lg:w-[320px] xl:left-8 xl:top-52 xl:h-[400px] xl:w-[400px]"
              />
              <img
                ref={image3}
                data-animation="animate__animated animate__fadeInLeft"
                src={
                  language == "ar" ? customerQueriesImgAr : customerQueriesImg
                }
                alt="black dresses collection"
                className="z-10 mx-auto w-[332px] md:w-[512px]"
              />
            </div>
            <div
              ref={item3}
              data-animation="animate__animated fade-in-slide-down"
              className="z-10 order-1 flex flex-1 flex-col gap-2 md:order-2 md:gap-3 md:py-20 md:pl-5 lg:gap-4 lg:px-10 lg:py-28"
            >
              <h1
                lang="en"
                className="text-[45px] font-extrabold leading-[54px] text-cyan ltr:text-left rtl:text-right md:text-6xl md:leading-[70px] lg:text-7xl"
              >
                03
              </h1>
              <p className="text-lg font-extrabold leading-5 md:text-xl md:leading-7 lg:text-2xl">
                <Trans>Responding to customer queries</Trans>
              </p>
              <p className="max-w-lg text-sm font-medium leading-4 md:text-base md:leading-6 lg:text-lg">
                <Trans>
                  Sometimes you receive messages with very specific requests. To
                  ensure a quick sale, make the experience easier for your
                  customers by tailoring collections to their needs.
                </Trans>
              </p>
            </div>
          </div>
          <div className="flex flex-col gap-8 md:gap-0 ltr:md:flex-row rtl:md:flex-row-reverse ">
            <div
              ref={item4}
              data-animation="animate__animated fade-in-slide-down"
              className="z-10 flex flex-1 flex-col gap-2 md:gap-3 md:py-20 md:pr-5 lg:gap-4 lg:px-10 lg:py-28"
            >
              <h1
                lang="en"
                className="text-[45px] font-extrabold leading-[54px] text-purple-dark ltr:text-left rtl:text-right md:text-6xl md:leading-[70px] lg:text-7xl"
              >
                04
              </h1>
              <p className="text-lg font-extrabold leading-5 md:text-xl md:leading-7 lg:text-2xl">
                <Trans>Creating personal collections</Trans>
              </p>
              <p className="max-w-lg text-sm font-medium leading-4 md:text-base md:leading-6 lg:text-lg">
                <Trans>
                  You know your top customers well, they buy from you often. Now
                  there’s a way to create personal collections for them and send
                  it to them over WhatsApp.
                </Trans>
              </p>
            </div>
            <div className="relative flex flex-1 items-center justify-center">
              <Sprite
                name="triangle-right"
                className="absolute top-0 h-[252px] w-[230px] translate-x-12 md:-top-4 md:left-24 md:h-[362px] md:w-[330px] md:translate-x-0 lg:left-20 lg:top-4 lg:h-[417px] lg:w-[380px] xl:left-44 xl:h-[470px] xl:w-[427px]"
              />
              <img
                ref={image4}
                data-animation="animate__animated animate__fadeInRight"
                src={
                  language == "ar"
                    ? personalCollectionsImgAr
                    : personalCollectionsImg
                }
                alt="anna and malek's collection"
                className="z-10 mx-auto w-[308px] md:w-[575px]"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
